import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { JWTFetchError, UnloggedError } from "./AuthErrors.js";
import { buildUrl } from "./utils.js"; // Types
import { AUTH_TYPE, QUERY_PARAMS_TYPE } from "./types.js";
function WithArlLogin(Base) {
  return class WithArlLoginAuth extends Base {
    /**
     * @deprecated ARL manipulation should be considered an internal implementation detail of account.deezer.com.
     * Auth team backend want to deprecate ARL manipulation in favor of refresh token login.
     * ARL is used to relog a user without asking for his credentials. We now have a dedicated autolog endpoint for that.
     * TL:DR If you know your user is logged with the legacy and not with auth service, redirect him to:
     * https://account.deezer.com/autolog?appname=your_app_name&path=your_redirect_path
     * @see https://github.deezerdev.com/Deezer/deezerlib/tree/master/packages/core/auth readme for more information
     */
    loginWithArl(arl, userId) {
      var _this = this;
      return _asyncToGenerator(function* () {
        let payload;
        if (arl) {
          payload = {
            arl,
            account_id: userId
          };
        }
        const fetchUrl = buildUrl({
          host: _this.host,
          authType: AUTH_TYPE.ARL,
          inputType: typeof payload !== 'undefined' ? QUERY_PARAMS_TYPE.PAYLOAD : QUERY_PARAMS_TYPE.COOKIE,
          tokenOutputType: _this.tokenOutputType,
          refreshTokenOutputType: _this.refreshTokenOutputType
        });
        const init = typeof payload !== 'undefined' ? {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        } : {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          credentials: 'include'
        };
        const response = yield _this.fetch.call(null, fetchUrl, init).catch(() => {
          throw new JWTFetchError('Could not fetch JWT Token with ARL');
        });
        if (!response.ok) {
          throw new UnloggedError(`Could not fetch JWT Token with ARL. Got error ${response.status}`);
        }
        if (_this.fetchShouldHaveReponse) {
          var _this$refreshTokenCac, _this$tokenCache;
          const {
            jwt,
            refresh_token
          } = yield response.json().catch(() => {
            throw new JWTFetchError('Response does not contain valid tokens');
          });
          (_this$refreshTokenCac = _this.refreshTokenCache) == null || _this$refreshTokenCac.set(refresh_token);
          (_this$tokenCache = _this.tokenCache) == null || _this$tokenCache.set(jwt);
          return jwt;
        }
        return null;
      })();
    }
  };
}
export default WithArlLogin;
//# sourceMappingURL=WithArlLogin.js.map